import { SUGGESTION_TYPE } from '../components/SearchBar/engines/types';

export type SearchBarClickParams = {
    siteId: number;
    locale: string;
};

export type TrackableSuggestionType =
    | typeof SUGGESTION_TYPE.CATEGORY
    | typeof SUGGESTION_TYPE.PRODUCT
    | typeof SUGGESTION_TYPE.SERVICE;

export const SUGGESTION_TARGET_NAME: Record<TrackableSuggestionType, string> = {
    CATEGORY: 'search_suggestion_category',
    PRODUCT: 'search_suggestion_product',
    SERVICE: 'search_suggestion_service',
};

export const SUGGESTION_TARGET_VALUE: Record<TrackableSuggestionType, string> =
    {
        CATEGORY: 'category',
        PRODUCT: 'article',
        SERVICE: 'service',
    };
